import { StatusContainer } from '@servicetitan/financing-utils-shared';
import { LoanDetails } from '../decision';
import ApprovedIllustration from '../../common/illustrations/checkmark-success.svg';

export const ApprovedSign = () => {
    return (
        <StatusContainer
            headline="Your loan application is complete"
            message=""
            image={ApprovedIllustration}
        >
            <LoanDetails />
        </StatusContainer>
    );
};
